import {isFeatureEnabled} from '@github-ui/feature-flags'

import type {TableDataType} from '../../components/table/table-data-type'
import type {Table} from './helpers/types'
import {useReactTable} from './use-react-table'
import {type TableProps, useReactTableV9} from './use-react-table-v9'

type ReactTableProps = TableProps & {
  children: (table: Table<TableDataType>) => React.ReactNode
}

export function ReactTable(props: ReactTableProps) {
  return isFeatureEnabled('memex_tanstack_table_v9') ? <ReactTableV9 {...props} /> : <ReactTableV8 {...props} />
}

function ReactTableV8({children, ...tableProps}: ReactTableProps) {
  const table = useReactTable(tableProps)
  return children(table)
}

function ReactTableV9({children, ...tableProps}: ReactTableProps) {
  const table = useReactTableV9(tableProps)
  return children(table as unknown as Table<TableDataType>)
}
